import { Button, DatePicker, message, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import imgSave from "@/components/table/saveImg";
import dataDefault from './data';
import { columns, compute } from "./compute";
import request from "@/method/axios";
import _ from 'lodash';
import Auth from "@/components/table/Auth";

const { MonthPicker } = DatePicker;
const TITLE = "月度回顾表 Monthly ES Review";

@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        loading: true,
        loadingSave: false,
        print: false,
        data4_1: [],
        key: "month_review"
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data, other = []) => {
        data = compute(data, other);
        this.setState({ data, loading: false, });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getData = async (date) => {
        try {
            let month = moment(date).format('M');
            const year = moment(date).format('YYYY');
            let data = _.cloneDeep(dataDefault);
            this.setState({ loading: true });
            const res = await request.post('/api/data', {
                list: [{
                    name: "data",
                    key: this.state.key, year, month
                },
                { name: "_5_1_1", key: "_5_1_1", year, month, noSort: 1 },
                { name: "_5_1_2", key: "_5_1_2", year, month, noSort: 1 },
                { name: "_5_1_3", key: "_5_1_3", year, month, noSort: 1 },
                { name: "_5_1_4", key: "_5_1_4", year, month, noSort: 1 },
                { name: "kpis", key: "kpis", year, month, noSort: 1 },
                { name: "_8_1", key: "_8_1", year, month, noSort: 1 },
                ]
            });
            if (res.data.data && res.data.data.length) data = res.data.data;
            console.log(data);

            this.setState({ data: compute(data, { ...res.data, month, year }), loading: false }, () => {
                // this.onSave();
            })
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }
    onSave = async () => {
        try {
            let { date, data: _data, key } = this.state;
            if (!date) return message.error('请选择年份月份');

            this.setState({ loadingSave: true });
            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            let data = _data.map((x, i) => ({ ...x, year, sort: i, month }));
            const postData = {
                data,
                year,
                month,
                key
            };
            const x = await request.post(`/api/save`, postData);
            this.setState({ loadingSave: false });
            if (x.code == 200) {
                message.success("保存成功！");
                if (!data[0].id) this.getData(this.state.date);
            }
        } catch (err) {
            this.setState({ loadingSave: false });
            console.error(err);
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_4_history', 1.5, '4.311', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} ${TITLE}`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, loading, key } = this.state;

        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_4_history"   >
                    <Row>{TITLE}</Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            disabledDate={v => {
                                if (moment(v).isAfter(moment('2023-12-31'))) return false;
                                return true;
                            }}
                            value={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getData(str);
                            }}
                        />
                    </Row>
                    <Table
                        columns={columns(this.onChange, date, print)}
                        dataSource={data}
                        size="middle"
                        id="table4_1_4"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
                <Row className="table-footer-btn">
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_monthlyreview">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/monthlyReview/index.js